import './src/styles/global.css';

export const wrapRootElement = ({ element }) => element;
export const wrapPageElement = ({ element }) => element;
